<template>
  <article id="project-analysis-tools" style="position: relative">
    <h2 class="sr-only">
      <VisibleText>Auto-analysis</VisibleText>
    </h2>
    <h2><VisibleText>Example API calls for report automation</VisibleText></h2>
    <div style="display: flex; flex-direction: row">
      <button
        class="btn-default"
        style="display: flex; margin: 1em; min-height: 1em; font-size: 0.8em"
        @click="autoAnalysis"
      >
        Re-run all analysis
      </button>
      <div style="margin: auto 0">
        <VisibleText
          >This will search through each drivers, performance, outliers, and text analysis and will
          re-run them. This is used to populate regular dashboards. If you set one as "last month",
          this will refresh to the latest "last month". For text, it will re-apply your analysis to
          new entries.
        </VisibleText>
      </div>
    </div>
    <div style="margin-top: 1rem; display: flex; flex-direction: row">
      <button
        class="btn-default"
        style="display: flex; margin: 1em; min-height: 1em; font-size: 0.8em"
        @click="analysisSummary"
      >
        Fetch project summary
      </button>
      <div style="margin: auto 0">
        <VisibleText
          >This will search through each drivers, performance, outliers, and text analysis and
          summarize all of the findings into charts and recommendations.
        </VisibleText>
      </div>
    </div>
    <h2><VisibleText>How to use these</VisibleText></h2>
    <VisibleText
      >Right click on you browser anywhere on this page and select 'Inspect' (Firefox or Chrome).
      Navigate to the Network tab before pressing the above buttons. Now when you hit "Re-run
      analysis" or "Fetch project summary", you will see an API request and an API response. You can
      re-use these requests for your own applications (reach out for more API support).</VisibleText
    >

    <!-- <div style="margin-top: 1rem">
      <button @click="generateObservations">Generate observations</button>
    </div> -->
  </article>
</template>

<script>
// components

// Mixins
import UserMixin from '@/utils/mixins/userMixin.js';

import ProjectMixin from '@/components/Project/Mixins/projectMixin.js';
import ProjectReportMixin from '@/components/Project/Mixins/projectReportMixin.js';

// Services
import AutoService from '@/services/autoService.js';

// Utils
import { fetchGroups } from '@/components/CustomTopicModel/Utils/fetch.js';
import { fetchProject } from '@/components/Project/Utils/fetch.js';

export default {
  name: 'ProjectAnalysisTools',
  components: {},
  mixins: [UserMixin, ProjectMixin, ProjectReportMixin],
  data() {
    return {
      AUTO_SERVICE: new AutoService(this.$pigeonline),
    };
  },
  methods: {
    async autoAnalysis() {
      if (this.project.datasets && this.project.datasets[0]) {
        //let fetchedCTMThemes = await fetchTopicModels(this.checkedThemes[0].source.manually_linked);

        this.topicModelGroups = await fetchGroups(); // The backend is actually checking objects for textAnalysisObject['customTopicModels']
        // if (this.topicModelGroups.length) {
        // }
        await this.AUTO_SERVICE.autoAnalysis({
          project_id: this.project.id,
          dataset_id: this.project.datasets[0],
          custom_topic_models: this.topicModelGroups.map((group) => ({ model_id: group.id })),
        });
        // Refresh project
        const fullProject = await fetchProject(this.project.id);
        await this.saveProject(fullProject);
      }
    },
    async analysisSummary() {
      await this.AUTO_SERVICE.analysisSummary({
        project_id: this.project.id,
        include_recommendations: true,
      });
      const fullProject = await fetchProject(this.project.id);
      await this.saveProject(fullProject);
    },
    // async generateObservations() {
    //   this.AUTO_SERVICE.generateObservations({
    //     project_id: this.project.id,
    //   });
    // },
    deepCloneObj(obj) {
      // deep clones an object using JSON stringify (data loss might occur)
      if (Array.isArray(obj)) {
        return obj.map((item) => JSON.parse(JSON.stringify(item)));
      } else if (typeof obj == 'object') {
        return JSON.parse(JSON.stringify(obj));
      }
    },
  },
};
</script>
